module.exports = __webpack_public_path__ + "img/NBard64_ua.67fc821d.webp";